import Reveal from "@/components/Reveal";
import { PROJECTS } from "@/data/content";
import { MapPin } from "lucide-react";

export default function Projects() {
  return (
    <section id="projects" data-testid="projects-section" className="bg-rc-bg py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal trackLabel="projects" className="mb-14">
          <div className="font-mono text-rc-red text-xs uppercase tracking-[0.3em] mb-5">03 — Selected Work</div>
          <h2 className="font-heading font-black text-rc-blue leading-[0.95] text-[clamp(2rem,5vw,4rem)] tracking-tight max-w-3xl">
            Roads, runways & highways across Florida.
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6">
          {PROJECTS.map((p, i) => (
            <Reveal
              key={p.title}
              delay={i * 0.08}
              className={`group ${i % 3 === 0 ? "md:col-span-2" : ""}`}
            >
              <div data-testid={`project-${i}`} className="relative overflow-hidden rounded-2xl bg-rc-charcoal">
                <div className={`overflow-hidden ${i % 3 === 0 ? "aspect-[21/9]" : "aspect-[16/10]"}`}>
                  {p.img && <img
                    src={p.img}
                    alt={p.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-rc-charcoal/90 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 p-6 lg:p-8">
                  <div className="flex items-center gap-2 font-mono text-rc-sand text-xs uppercase tracking-[0.2em] mb-2">
                    <MapPin size={13} /> {p.location}
                  </div>
                  <h3 className="font-heading font-bold text-white text-2xl lg:text-3xl">{p.title}</h3>
                  <div className="text-white/70 text-sm mt-1">{p.type}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
